<ion-modal [isOpen]="show" [cssClass]="cssClass" [ngClass]="{'opacity-0': transparent}" [canDismiss]="true" [backdropDismiss]="true"
  (ionBackdropTap)="$any(onBackdropTap())" (ionModalDidDismiss)="onDidDismiss()">
  <ng-template>
    <div class="flex flex-col gap-4 text-center px-2 pt-6 pb-5">
      <div class="flex items-center justify-center flex-col px-3">
        <ion-button mode="ios" fill="clear" (click)="toggleShow()" class="absolute top-0 right-0" *ngIf="close">
          <ion-icon color="secondary" src="../../../assets/svg/close.svg" class="text-[20px]" />
        </ion-button>
        <ng-content></ng-content>
        <div class="w-full">
          <ion-button *ngIf="type === 'accept'" mode="ios" (click)="confirmAction()" size="small"
            [disabled]="acceptDisabled" class="app-shadow mt-6 w-full basic-rounded accept" color="primary">
            {{ buttonText | translate }}
          </ion-button>
        </div>
        <div *ngIf="type === 'confirm'" class="flex gap-6 mx-6 mt-4">
          <ion-button mode="ios" size="small" class="flex-1 option app-shadow" color="primary"
            (click)="confirmAction()">
            {{ 'DIALOG.YES' | translate }}
          </ion-button>
          <ion-button mode="ios" size="small" color="primary" class="flex-1 option app-shadow" (click)="toggleShow()">
            {{ 'DIALOG.NO' | translate }}
          </ion-button>
        </div>
      </div>
    </div>

    <div class="text-start m-6 mt-2 text-sm text-gray-500" *ngIf="stripeDisclaimer" [innerHTML]="'DIALOG.STRIPE_DISCLAIMER' | translate">
    </div>
  </ng-template>
</ion-modal>